import { axiosDelete, axiosGet, axiosPatch, axiosPost } from './axios.helpers';

export const getAccountManagers = async (pageNumber, pageSize) =>
  axiosGet(
    `/account-managers?page[number]=${pageNumber + 1}&page[size]=${pageSize}`,
  );

export const showAccountManager = async (id) =>
  axiosGet(`/account-managers/${id}`);

export const updateAccountManager = async (id, accountManager) => {
  const { firstName, lastName, email, rate } = accountManager;

  await axiosPatch(`/account-managers/${id}`, {
    first_name: firstName,
    last_name: lastName,
    email,
    rate,
  });
};

export const createAccountManager = async (accountManager) => {
  const { firstName, lastName, email, rate } = accountManager;

  await axiosPost('/account-managers', {
    first_name: firstName,
    last_name: lastName,
    email,
    rate,
  });
};

export const deleteAccountManager = async (id) => {
  await axiosDelete(`/account-managers/${id}`);
};
